<template>
  <f7-card class="card-raised">
    <f7-card-content :padding="false" class="video-container">
      <iframe :src="src" :title="title" frameborder="0" allowfullscreen class="video-frame"></iframe>
    </f7-card-content>
  </f7-card>
</template>

<script>

  export default {
    components: {},

    props: ['src', 'title'],

    mixins: [],

    data: function () {
      return {
        //
      };
    },

    computed: {
      //
    },

    created() {
      //
    },

    mounted() {
      //
    },

    methods: {
      //
    },

    watch: {
      //
    }
  };
</script>
